import {
	createFileRoute,
	Outlet,
	Link,
	useNavigate,
} from "@tanstack/react-router";
import {
	Card,
	CardHeader,
	CardTitle,
	CardDescription,
	CardContent,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PencilLine, ArrowLeft } from "lucide-react";

// UI
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

import { Separator } from "@/components/ui/separator";

// Icons

// Magic Value
import siteConfig from "@/config/site";

export const Route = createFileRoute(
	"/_layout-private/report/finance/$id/_layout",
)({
	component: FinanceDetail,
});

function FinanceDetail() {
	const { id } = Route.useParams();
	const navigate = useNavigate();

	const sidebarMenus = siteConfig.getFinanceSideBarMenus(id);

	return (
		<>
			<Breadcrumb>
				<BreadcrumbList>
					<BreadcrumbItem>
						<BreadcrumbLink>
							<Link to="/report/finance">ລາຍງານການເງິນລັດວິສາຫະກິດ</Link>
						</BreadcrumbLink>
					</BreadcrumbItem>
					<BreadcrumbSeparator />

					<BreadcrumbItem>
						<BreadcrumbPage>ສ້າງລາຍງານການເງິນລັດວິສາຫະກິດ</BreadcrumbPage>
					</BreadcrumbItem>
				</BreadcrumbList>
			</Breadcrumb>

			{/* <div className="flex flex-row w-full h-full gap-2 py-[24px] overflow-y-auto">
				<nav className="w-[20%]">
					<ul>
						{sidebarMenus.map((menu) => (
							<li key={menu.name}>
								<Link
									to={menu.href}
									className="px-4 py-2 rounded-md  flex items-center [&.active]:font-bold [&.active]:bg-muted [&.active]:text-primary  text-[14px] "
								>
									{menu.name}
								</Link>
							</li>
						))}
					</ul>
				</nav>

				<div className="w-[80%]">
					<Outlet />
				</div>
			</div> */}

			<div className="relative flex flex-row h-screen p-4 overflow-y-auto scrollbar-hide ">
				<aside className="w-[20%]  border-r sticky top-0 z-10 	">
					<nav className="mt-[40px] space-y-4 ">
						<ul>
							{sidebarMenus.map((menu) => (
								<li key={menu.name}>
									<Link
										to={menu.href}
										className="px-4 py-2 rounded-md  flex items-center [&.active]:font-bold [&.active]:bg-muted [&.active]:text-primary  text-[14px] "
									>
										{menu.name}
									</Link>
								</li>
							))}
						</ul>
					</nav>
				</aside>
				<div className=" w-[80%] h-screen ">
					<main className="py-[24px]  ">
						<Outlet />
					</main>
				</div>
			</div>
		</>
	);
}
